var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2Done(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 60,
    viewBox: "0 0 228 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_64_1611)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_64_1611",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.152 3.01544C210.44 1.76914 209.114 1 207.679 1H6.89272C3.82143 1 1.89596 4.31793 3.41975 6.98456L14.866 27.0154C15.5687 28.2452 15.5687 29.7548 14.866 30.9846L3.41975 51.0154C1.89596 53.6821 3.82142 57 6.89271 57H207.679C209.114 57 210.44 56.2309 211.152 54.9846L224.866 30.9846C225.569 29.7548 225.569 28.2452 224.866 27.0154L211.152 3.01544Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.152 3.01544C210.44 1.76914 209.114 1 207.679 1H6.89272C3.82143 1 1.89596 4.31793 3.41975 6.98456L14.866 27.0154C15.5687 28.2452 15.5687 29.7548 14.866 30.9846L3.41975 51.0154C1.89596 53.6821 3.82142 57 6.89271 57H207.679C209.114 57 210.44 56.2309 211.152 54.9846L224.866 30.9846C225.569 29.7548 225.569 28.2452 224.866 27.0154L211.152 3.01544Z",
    fill: "#EAF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.866 27.0154L13.9977 27.5116H13.9977L14.866 27.0154ZM14.866 30.9846L13.9977 30.4884H13.9977L14.866 30.9846ZM224.866 30.9846L225.734 31.4807V31.4807L224.866 30.9846ZM224.866 27.0154L225.734 26.5193V26.5193L224.866 27.0154ZM211.152 3.01544L212.02 2.51931L211.152 3.01544ZM211.152 54.9846L212.02 55.4807L211.152 54.9846ZM6.89272 2H207.679V0H6.89272V2ZM15.7342 26.5193L4.28799 6.48842L2.55151 7.4807L13.9977 27.5116L15.7342 26.5193ZM15.7342 31.4807C16.6126 29.9435 16.6126 28.0565 15.7342 26.5193L13.9977 27.5116C14.5248 28.4339 14.5248 29.5661 13.9977 30.4884L15.7342 31.4807ZM4.28799 51.5116L15.7342 31.4807L13.9977 30.4884L2.55151 50.5193L4.28799 51.5116ZM207.679 56H6.89271V58H207.679V56ZM223.998 30.4884L210.283 54.4884L212.02 55.4807L225.734 31.4807L223.998 30.4884ZM223.998 27.5116C224.525 28.4339 224.525 29.5661 223.998 30.4884L225.734 31.4807C226.613 29.9435 226.613 28.0565 225.734 26.5193L223.998 27.5116ZM210.283 3.51158L223.998 27.5116L225.734 26.5193L212.02 2.51931L210.283 3.51158ZM2.55151 50.5193C0.646775 53.8526 3.0536 58 6.89271 58V56C4.58925 56 3.14515 53.5116 4.28799 51.5116L2.55151 50.5193ZM207.679 2C208.755 2 209.749 2.57686 210.283 3.51158L212.02 2.51931C211.13 0.961432 209.473 0 207.679 0V2ZM207.679 58C209.473 58 211.13 57.0386 212.02 55.4807L210.283 54.4884C209.749 55.4231 208.755 56 207.679 56V58ZM6.89272 0C3.05361 0 0.646773 4.14741 2.55151 7.4807L4.28799 6.48842C3.14515 4.48845 4.58925 2 6.89272 2V0Z",
    fill: "#2BB76B",
    mask: "url(#path-1-inside-1_64_1611)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_64_1611",
    x: 0.88681,
    y: 0,
    width: 226.506,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_64_1611"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_64_1611",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Done);
export default __webpack_public_path__ + "static/media/2done.93051461d4b613e95c4071cf049eb103.svg";
export { ForwardRef as ReactComponent };